import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import Content from '../components/Content';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { computed, toRefs } from 'vue';
import { useUserStore } from '@/stores/user';
export default {
  __name: 'Default',
  setup(__props) {
    const user = useUserStore();
    const {
      headerFlag
    } = toRefs(user);
    const isInner = computed(() => {
      return window.__POWERED_BY_WUJIE__;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [!_unref(isInner) && _unref(headerFlag) ? (_openBlock(), _createBlock(_unref(Header), {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_unref(Content)), !_unref(isInner) && _unref(headerFlag) ? (_openBlock(), _createBlock(_unref(Footer), {
        key: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
};